export default "__VITE_ASSET__DzhFWvtp__"